import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  id: "registration-fields"
}
const _hoisted_4 = { class: "card py-2 px-2" }
const _hoisted_5 = { width: "100%" }
const _hoisted_6 = { class: "py-2 px-2" }
const _hoisted_7 = { class: "py-2" }
const _hoisted_8 = ["value", "onUpdate:modelValue"]
const _hoisted_9 = { class: "py-2" }
const _hoisted_10 = ["value", "onUpdate:modelValue"]
const _hoisted_11 = { class: "py-2 text-muted" }
const _hoisted_12 = { class: "hpy-2 text-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_create_registration_field = _resolveComponent("create-registration-field")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[17] || (_cache[17] = _createElementVNode("h1", null, "Partner Registration Fields", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected_partner) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getPartnerFields(_ctx.selected_partner)))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("option", { value: null }, " -- Select A Partner --", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
              return (_openBlock(), _createElementBlock("option", {
                key: partner.id,
                value: partner.id
              }, _toDisplayString(partner.name), 9, _hoisted_2))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selected_partner]
          ]),
          (_ctx.selected_partner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("form", {
                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("table", _hoisted_5, [
                      _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "header-row py-2" }, "Registration Field"),
                          _createElementVNode("th", { class: "header-row py-2" }, "Show on Registration"),
                          _createElementVNode("th", { class: "header-row py-2" }, "Make Field Required"),
                          _createElementVNode("th", { class: "header-row py-2" }, "Type"),
                          _createElementVNode("th", { class: "header-row py-2 text-center" }, "Delete")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("tr", null, [
                          _createElementVNode("td", { class: "py-2 px-2" }, "First Name"),
                          _createElementVNode("td", { class: "py-2" }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              name: "fname",
                              checked: "",
                              disabled: ""
                            })
                          ]),
                          _createElementVNode("td", { class: "py-2" }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              name: "fname_require",
                              checked: "",
                              disabled: ""
                            })
                          ]),
                          _createElementVNode("td", { class: "py-2 text-muted" }, "input"),
                          _createElementVNode("td", { class: "py-2" }, " ")
                        ], -1)),
                        _cache[12] || (_cache[12] = _createElementVNode("tr", null, [
                          _createElementVNode("td", { class: "py-2 px-2" }, "Last Name"),
                          _createElementVNode("td", { class: "py-2" }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              name: "lname",
                              checked: "",
                              disabled: ""
                            })
                          ]),
                          _createElementVNode("td", { class: "py-2" }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              name: "lname_require",
                              checked: "",
                              disabled: ""
                            })
                          ]),
                          _createElementVNode("td", { class: "py-2 text-muted" }, "input"),
                          _createElementVNode("td", { class: "py-2" }, " ")
                        ], -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("tr", null, [
                          _createElementVNode("td", { class: "py-2 px-2" }, "Email"),
                          _createElementVNode("td", { class: "py-2" }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              name: "email",
                              checked: "",
                              disabled: ""
                            })
                          ]),
                          _createElementVNode("td", { class: "py-2" }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              name: "email_require",
                              checked: "",
                              disabled: ""
                            })
                          ]),
                          _createElementVNode("td", { class: "py-2 text-muted" }, "input"),
                          _createElementVNode("td", { class: "py-2" }, " ")
                        ], -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.existingFields, (field, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: field.id
                          }, [
                            _createElementVNode("td", _hoisted_6, _toDisplayString(field.title), 1),
                            _createElementVNode("td", _hoisted_7, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                value: field.active,
                                name: "active",
                                "onUpdate:modelValue": ($event: any) => ((field.active) = $event)
                              }, null, 8, _hoisted_8), [
                                [_vModelCheckbox, field.active]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_9, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                value: field.active,
                                name: "required",
                                "onUpdate:modelValue": ($event: any) => ((field.required) = $event)
                              }, null, 8, _hoisted_10), [
                                [_vModelCheckbox, field.required]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_11, _toDisplayString(field.field_type), 1),
                            _createElementVNode("td", _hoisted_12, [
                              (field.partner_id != 0)
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteRegistrationModal())),
                                    class: "cursor-pointer text-primary fa fa-trash"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_modal, {
                              modelValue: _ctx.deleteRegistrationField,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.deleteRegistrationField) = $event))
                            }, {
                              header: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("Permanently Delete Field")
                              ])),
                              default: _withCtx(() => [
                                _cache[9] || (_cache[9] = _createElementVNode("p", null, "Are you sure you want to delete this Registration Field?", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary btn-xs float-end ms-4",
                                  onClick: ($event: any) => (_ctx.removeRegistrationField(field.id,index))
                                }, "Delete", 8, _hoisted_13),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("button", {
                                  class: "btn btn-xs btn-secondary-alt float-end",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeleteRegistrationModal()))
                                }, "Cancel")
                              ]),
                              _: 2
                            }, 1032, ["modelValue"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ], 32)
                ]),
                _createVNode(_component_create_registration_field, {
                  "partner-id": _ctx.selected_partner,
                  onAddNewField: _ctx.addRegistrationField
                }, {
                  trigger: _withCtx((triggerProps) => [
                    _createElementVNode("button", {
                      class: "btn btn-primary mt-4 px-5 fw-bold",
                      onClick: triggerProps.click
                    }, _cache[15] || (_cache[15] = [
                      _createTextVNode("Add Custom Field "),
                      _createElementVNode("i", { class: "fas fa-plus-circle" }, null, -1)
                    ]), 8, _hoisted_14)
                  ]),
                  _: 1
                }, 8, ["partner-id", "onAddNewField"]),
                _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("button", {
                  class: "btn btn-primary mt-4 px-5 fw-bold",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveFieldProps && _ctx.saveFieldProps(...args)))
                }, "Save Custom Registration")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}